jQuery(document).ready(function($) {
  $('.search').click(function(){
    console.log('click');
    $('#search-box').toggle('slide');
  });
});